import { GoAButton, GoAIcon, GoASpacer } from '@abgov/react-components';
import { useNavigate } from 'react-router-dom';

export const ErrorComponent = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        margin: '0',
        padding: '0',
        maxWidth: 'none',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        className="error-component"
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          width: '600px',
        }}
      >
        <GoASpacer vSpacing="xl" />

        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '120px',
            height: '120px',
            borderRadius: '60px',
            backgroundColor: 'var(--Color-Greyscale-100, #F1F1F1)',
          }}
        >
          <ion-icon
            name="car-sport-outline"
            style={{
              fontSize: '5rem',
              paddingTop: '1rem',
            }}
          ></ion-icon>{' '}
        </div>
        <GoASpacer vSpacing="xl" />

        <div
          style={{
            width: '110px',
            height: '8px',
            backgroundColor: 'var(--goa-color-brand-default)',
          }}
        >
          {' '}
        </div>

        <div style={{ width: '400px' }}>
          <h2>Report My Collision has encountered an issue</h2>
        </div>
        <GoASpacer vSpacing="xl" />
        <div>
          Check back later to see if the issue has been resolved. If the issue
          persists, you can contact our support team at{' '}
          <a href="mailto:tec.collisionsupport@gov.ab.ca">
            tec.collisionsupport@gov.ab.ca
          </a>
          . Be sure to include what you were trying to do, along with the
          approximate date and time. You may close this window or return to the
          Report My Collision homepage.
        </div>
        <GoASpacer vSpacing="xl" />
        <GoAButton
          onClick={() => {
            navigate('/');
          }}
        >
          Return to homepage
        </GoAButton>
      </div>
    </div>
  );
};
